import classNames from 'classnames';
import React, { ReactElement } from 'react';

import Row from '@Components/layout/Row';
import Select, { OptionItem, SelectSizes } from '@Components/Select';
import Typography from '@Components/Typography';
import { MessageKeysWithoutParams } from '@Utils/translation';

import styles from './SelectFilter.module.scss';

interface SelectFilterProps<T> {
  onChange: (value: T) => void;
  options: OptionItem[];
  filterLabel?: string;
  filterValueLabel?: MessageKeysWithoutParams;
  defaultValue: T;
  size?: SelectSizes;
  smallerSelect?: boolean;
  className?: string;
  selectedValue?: OptionItem;
  localizeSelectLabels?: boolean;
}

const SelectFilter: <T>(props: SelectFilterProps<T>) => ReactElement = props => {
  const {
    onChange,
    options,
    filterLabel,
    filterValueLabel,
    selectedValue,
    defaultValue,
    size = 'm',
    smallerSelect,
    className,
    localizeSelectLabels = true,
  } = props;

  return (
    <Row justifyEnd alignCenter className={classNames(styles.filter, className)} constant>
      {filterLabel && <Typography className={styles.label} tag="span" color="gray" size="s" msg={filterLabel} />}
      <Select
        options={options}
        placeholder={filterValueLabel}
        size={size}
        localizeSelectLabels={localizeSelectLabels}
        selectedValue={selectedValue || options.find(item => item.value === defaultValue)}
        onChange={value => onChange(value.value)}
        smallerSelect={smallerSelect}
      />
    </Row>
  );
};

export default SelectFilter;
